import { useTable } from "react-table";
import React from "react";
import { TableData } from "./style";

interface TableProp {
  data?: any;
  columns?: any;
}

export const CustomTable: React.FC<TableProp> = ({ data, columns }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  return (
    <>
      {
        <table
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup: any) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column: any) => (
                  <th
                    className="th"
                    {...column.getHeaderProps()}
                    style={{ textAlign: "start" }}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row: any) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} style={{ textAlign: "start" }}>
                  {row.cells.map((cell: any) => {
                    return (
                      <TableData
                        {...cell.getCellProps()}
                        style={{ textAlign: "start" }}
                      >
                        {cell.render("Cell")}
                      </TableData>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      }

    </>
  );
};